// Add your custom JS here.



(function($){

    function openCV(e){
        e.target.parentElement.classList.add('open');
        let newCvHeight = $('#cv').height()+70;
        $('#cv-wrapper').css("max-height" , newCvHeight+"px");
    }
    
    function closeCV(e){
        e.target.parentElement.classList.remove('open');
        let newCvHeight = 500;
        if($('#cv-picture').length){
            console.log('picture');
            newCvHeight = $('#cv-picture').height();
        }
        $('#cv-wrapper').css("max-height" , newCvHeight+"px");
    }
    
    window.openCV = openCV;
    window.closeCV = closeCV;

    $( document ).ready(function() {
        cvSize();
    })
    $( window ).on( "resize", function() {
        cvSize();
    })
    function cvSize(){
        if($('#cv-wrapper').length && !$('#cv-wrapper').hasClass('open')){
            let newCvHeight = 500;
            if($('#cv-picture').length){
                newCvHeight = $('#cv-picture').height();
            }
            $('#cv-wrapper').css("max-height" , newCvHeight+"px");
        }
        if($('#cv-wrapper').length && $('#cv-wrapper').hasClass('open')){
            let newCvHeight = $('#cv').height()+70;
            $('#cv-wrapper').css("max-height" , newCvHeight+"px");
        }
    }
})(jQuery)